/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Pricing_Compare_Submissions_FreeInputs */

const en_landing_pricing_compare_submissions_free = /** @type {(inputs: Landing_Pricing_Compare_Submissions_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5 total`)
};

const zh_landing_pricing_compare_submissions_free = /** @type {(inputs: Landing_Pricing_Compare_Submissions_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`共 5 次`)
};

/**
* | output |
* | --- |
* | "5 total" |
*
* @param {Landing_Pricing_Compare_Submissions_FreeInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const landing_pricing_compare_submissions_free = /** @type {((inputs?: Landing_Pricing_Compare_Submissions_FreeInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Pricing_Compare_Submissions_FreeInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_pricing_compare_submissions_free(inputs)
	return zh_landing_pricing_compare_submissions_free(inputs)
});
export { landing_pricing_compare_submissions_free as "landing.pricing.compare_submissions_free" }